// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"447":"b043e3f6","490":"7d79878e","967":"beb610ba"}[chunkId] + ".chunk.js";
};